import ToggleOn from 'assets/icons/md/md-toggle-on.svg'

ToggleOn.displayName = 'ToggleOm'
export default ToggleOn
